import React, { useState, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import {
  Button,
  FormControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Switch,
  TextField,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import {
  makeStyles,
  createStyles,
  Theme as AugmentedTheme,
} from '@material-ui/core/styles';

import MessageForm from './MessageForm';
import RangeForm from './RangeForm';
import { config } from 'config';

const useStyles = makeStyles((theme: AugmentedTheme) =>
  createStyles({
    submit: {
      margin: theme.spacing(3, 0, 2),
      display: 'inline',
    },
    sectionOutline: {
      width: '100%',
      border: '1px solid #aaffaa',
      background: '#efefef',
      color: '#000000',
      padding: '10px 20px',
      margin: '0 auto',
      marginTop: '10px',
    },
  }),
);

function SwitchContainer({ _id, label, hierarchy, value, handleSwitch }) {
  const [state, setState] = React.useState(value === 'true');

  const handleChange = event => {
    setState(event.target.checked);
    handleSwitch({
      _id,
      hierarchy,
      value: '' + event.target.checked,
    });
  };
  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={state}
            onChange={handleChange}
            value={state}
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        }
        label={label}
        labelPlacement="start"
      />
    </div>
  );
}

export default function ParamForm(props) {
  const [value, setValue] = useState(props.item.value);
  const [enabled, setEnabled] = useState(props.item.value.enabled);
  const classes = useStyles();
  const editorRef = (useRef(null) as unknown) as { current: unknown };
  let timeoutId;
  //props.setPrevItem(props.item);
  return (
    <section className={classes.sectionOutline}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            style={{ display: 'inline-block', clear: 'none' }}
          >
            {props.item.title}
          </Typography>
          {props.item.type === 'NotificationObject' ? (
            <FormControlLabel
              control={
                <Switch
                  checked={enabled}
                  onChange={data => {
                    const newValue = {
                      ...value,
                      enabled: data.target.checked,
                    };
                    setEnabled(data.target.checked);
                    setValue(newValue);
                  }}
                  inputProps={{ 'aria-label': 'Notificación Habilitada' }}
                />
              }
              label="Habilitado"
              style={{ marginLeft: 20, position: 'absolute', right: 100 }}
            />
          ) : null}
          {props.item.description ? (
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: props.item.description }}
            ></Typography>
          ) : null}

          {props.item.type === 'Boolean' ? (
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <SwitchContainer
                  value={props.item.value}
                  hierarchy={props.item.hierarchy}
                  handleSwitch={props.updateParam}
                  label=""
                  _id={props.item._id}
                />
              </FormGroup>
            </FormControl>
          ) : null}
        </Grid>
      </Grid>
      <form name={props.item.hierarchy}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {props.item.type === 'String' ||
            props.item.type === 'SelectListNumberValues' ||
            props.item.type === 'SelectListStringValues' ||
            props.item.type === 'Email' ||
            props.item.type === 'Object' ||
            props.item.type === 'Url' ? (
              <TextField
                name={props.item.hierarchy}
                defaultValue={props.item.value}
                onChange={e => {
                  const val = e.target.value;
                  console.log('timeoutId: ' + timeoutId);
                  clearTimeout(timeoutId);
                  timeoutId = setTimeout(() => {
                    console.log('updating...');
                    props.updateParam({
                      _id: props.item._id,
                      hierarchy: props.item.hierarchy,
                      value: val,
                    });
                  }, 1000);
                }}
                variant="outlined"
                margin="normal"
                required
                fullWidth
              />
            ) : null}
            {props.item.type === 'Integer' ? (
              <TextField
                name={props.item.hierarchy}
                defaultValue={props.item.value}
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                onFocus={e => {
                  //e.target.blur();
                }}
                onChange={e => {
                  if (parseInt(e.target.value) > 0) {
                    setValue(e.target.value);
                  } else {
                    e.target.value = '' + 0;
                    setValue(e.target.value);
                  }
                  const val = e.target.value;
                  clearTimeout(timeoutId);
                  timeoutId = setTimeout(() => {
                    props.updateParam({
                      _id: props.item._id,
                      hierarchy: props.item.hierarchy,
                      value: val,
                    });
                  }, 1000);
                }}
              />
            ) : null}
            {props.item.type === 'Double' ? (
              <TextField
                name={props.item.hierarchy}
                defaultValue={props.item.value}
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                onFocus={e => {
                  //e.target.blur();
                }}
                onChange={e => {
                  if (parseFloat(e.target.value) > 0) {
                    setValue(e.target.value);
                  } else {
                    e.target.value = '' + 0;
                    setValue(e.target.value);
                  }
                  const val = e.target.value;
                  clearTimeout(timeoutId);
                  timeoutId = setTimeout(() => {
                    props.updateParam({
                      _id: props.item._id,
                      hierarchy: props.item.hierarchy,
                      value: val,
                    });
                  }, 1000);
                }}
              />
            ) : null}
            {props.item.type === 'RichText' ? (
              <>
                <Editor
                  apiKey={config.UI.tinyAPIKey}
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  initialValue={props.item.value}
                  init={{
                    height: 300,
                    menubar: true,
                    relative_urls: false,
                    convert_urls: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | ' +
                      'bold italic superscript subscript backcolor | alignleft aligncenter ' +
                      'alignright alignjustify | bullist numlist outdent indent | ' +
                      'removeformat | link image | code | help',
                    content_style:
                      'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                  }}
                  onEditorChange={() => {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(() => {
                      props.updateParam({
                        _id: props.item._id,
                        hierarchy: props.item.hierarchy,
                        // @ts-ignore
                        value: editorRef.current.getContent(),
                      });
                    }, 2000);
                  }}
                />
              </>
            ) : null}
            {props.item.type === 'Password' ? (
              <TextField
                name={props.item.hierarchy}
                type="password"
                defaultValue={props.item.value}
                onChange={e => {
                  const val = e.target.value;
                  clearTimeout(timeoutId);
                  timeoutId = setTimeout(() => {
                    props.updateParam({
                      _id: props.item._id,
                      hierarchy: props.item.hierarchy,
                      value: val,
                    });
                  }, 2000);
                }}
                variant="outlined"
                margin="normal"
                required
                fullWidth
              />
            ) : null}
            {props.item.type === 'NotificationObject' ? (
              <MessageForm
                message={value}
                updateMessage={msg => {
                  props.item.value = msg;
                  props.updateParam({
                    _id: props.item._id,
                    hierarchy: props.item.hierarchy,
                    value: msg,
                  });
                }}
              />
            ) : null}
            {props.item.type === 'Range' ? (
              <RangeForm
                range={props.item.value}
                updateRange={range => {
                  props.updateParam({
                    _id: props.item._id,
                    hierarchy: props.item.hierarchy,
                    value: range,
                  });
                }}
              />
            ) : null}
          </Grid>
          {false ? (
            <Grid item xs={2}>
              <Button
                id="submitButton"
                name="submitButton"
                type="button"
                onClick={() => {
                  if (value && props.item.value !== value) {
                    props.updateParam({
                      _id: props.item._id,
                      hierarchy: props.item.hierarchy,
                      value,
                    });
                  }
                }}
                fullWidth
                variant="contained"
                className={classes.submit}
              >
                GUARDAR
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </form>
    </section>
  );
}
